import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { EASE, JOB_PORTAL_URL } from "./constants";

export const Header = () => (
  <motion.header
    initial={{ opacity: 0, y: -16 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, ease: EASE }}
    className="fixed inset-x-0 top-0 z-50 border-b border-[#E2F0E6]/80 bg-white/75 backdrop-blur-xl"
    data-testid="site-header"
  >
    <nav
      aria-label="Primary"
      className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8"
    >
      <Logo />
      <a
        href={JOB_PORTAL_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="header-job-portal-button"
        className="ag-focus group inline-flex items-center gap-1.5 rounded-full border-[1.5px] border-[#16803C] px-4 py-2 text-xs font-semibold text-[#16803C] transition-colors duration-300 hover:bg-[#16803C] hover:text-white sm:px-5 sm:text-sm"
      >
        Explore Job Portal
        <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
      </a>
    </nav>
  </motion.header>
);
